import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/ru";
import dayjs, { Dayjs } from "dayjs";
import { GridLegacy, IconButton, Popover } from "@mui/material";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import TodayIcon from "@mui/icons-material/Today";
import React, { useEffect } from "react";
import { getDateForDateObj, getDateOfInt, getStrDateOfDateObj } from "../../MainPage/Tools/Tools";

interface DateCalendarEditorProps {
  open: boolean;
  inputValue: string;
  objRef?: string | number;
  id?: string;
  anchorEl?: null | Element;
  valueChanged: React.RefObject<boolean>;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  handleClose: () => void;
  onEditValue: (ev: any, newValue: any, textchanged?: string) => void;
}

export default function DateCalendarEditor(props: DateCalendarEditorProps) {
  const { inputValue, open, valueChanged, anchorEl, id, objRef, setInputValue, onEditValue, handleClose } = props;
  const calendar = React.useRef<HTMLDivElement | null>(null);

  const [value, setValue] = React.useState<Dayjs | null>(null);

  useEffect(() => {
    if (!open) return;
    if ((!inputValue || inputValue === ".." || inputValue === "__.__.____") && (!objRef || objRef === "0")) {
      const date = new Date();
      setValue(dayjs(getDateForDateObj(getStrDateOfDateObj(date))));
    }
  }, []);

  useEffect(() => {
    if (!open) return;
    if ((!inputValue || inputValue === ".." || inputValue === "__.__.____") && (!objRef || objRef === "0")) {
      return;
    }
    if (inputValue) {
      setValue(dayjs(getDateForDateObj(inputValue)));
      return;
    }
    if (objRef !== undefined) setValue(dayjs(getDateForDateObj(getDateOfInt(objRef))));
  }, [inputValue, objRef, open]);

  useEffect(() => {
    if (calendar.current) {
      const prev: any = calendar.current.querySelector(".MuiIconButton-edgeEnd");
      if (prev) {
        prev.title = "Предыдущий месяц";
      }
      const next: any = calendar.current.querySelector(".MuiIconButton-edgeStart");
      if (next) {
        next.title = "Следующий месяц";
      }
    }
  }, [calendar.current]);

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={() => {
        handleClose();
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <div ref={calendar} calendar="">
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
          <DateCalendar
            showDaysOutsideCurrentMonth
            views={["year", "month", "day"]}
            value={value}
            onChange={(newValue, comand) => {
              valueChanged.current = true;
              let value = `${newValue.get("date") < 10 ? `0${newValue.get("date")}` : newValue.get("date")}.${
                newValue.month() + 1 < 10 ? `0${newValue.month() + 1}` : newValue.month() + 1
              }.${newValue.year()}`;

              setInputValue(value);
              setValue(newValue);
              if (comand === "finish") {
                onEditValue(undefined, value);
                handleClose();
              }
            }}
          />
        </LocalizationProvider>

        <GridLegacy container direction="row" justifyContent="space-between" alignItems="center">
          <IconButton
            size="small"
            title="В начало года"
            onClick={() => {
              const strDate = getDateForDateObj(inputValue);
              const date = strDate ? new Date(strDate) : new Date();
              setInputValue(`01.01.${date.getFullYear()}`);
              setValue(dayjs(getDateForDateObj(`01.01.${date.getFullYear()}`)));
              valueChanged.current = true;
            }}
          >
            <KeyboardDoubleArrowLeftIcon />
          </IconButton>
          <IconButton
            title="Текущая дата"
            onClick={() => {
              const date = new Date();
              setInputValue(
                `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}.${
                  date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
                }.${date.getFullYear()}`,
              );
              setValue(
                dayjs(
                  getDateForDateObj(
                    `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}.${
                      date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
                    }.${date.getFullYear()}`,
                  ),
                ),
              );
              valueChanged.current = true;
            }}
            size="small"
          >
            <TodayIcon />
          </IconButton>
          <IconButton
            title="В конец года"
            onClick={() => {
              const strDate = getDateForDateObj(inputValue);
              const date = strDate ? new Date(strDate) : new Date();
              setInputValue(`31.12.${date.getFullYear()}`);
              setValue(dayjs(getDateForDateObj(`31.12.${date.getFullYear()}`)));
              valueChanged.current = true;
            }}
            size="small"
          >
            <KeyboardDoubleArrowRightIcon />
          </IconButton>
        </GridLegacy>
      </div>
    </Popover>
  );
}
